import {PatientAgeServiceType} from '@/components/commons/patient-age-service-type/PatientAgeServiceType'
import {DetailsField, DetailsFieldsGrid} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {CheckIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {PatientExtended} from '@/features/patients/types'
import {patientDisabilitiesToLabel, patientTransportationModesToLabel} from '@/features/patients/utils'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'

export const PatientMedicalInfoDetails = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()

    const birthDate = useMemo(() => new Date(patient.birthDate), [patient.birthDate])

    return (
        <DetailsFieldsGrid>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:service')}
                </Text>
                <Text weight="500" size="textMd">
                    <PatientAgeServiceType birthDate={birthDate} />
                </Text>
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:neuromuscular_neurological_diagnosis')}
                </Text>
                {patient.neuromuscularDiagnosis ? (
                    <Text weight="500" size="textMd" palette="success" shade="700">
                        <Flexbox render="span" align="center" gap={1}>
                            <CheckIcon size={16} />
                            {patient.neuromuscularDiagnosis.name}
                        </Flexbox>
                    </Text>
                ) : (
                    <Text weight="500" size="textMd">
                        -
                    </Text>
                )}
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:protected_categories')}
                </Text>
                <Text weight="500" size="textMd">
                    {patient.protectedCategory ? t('patients:belonging') : t('patients:not_belonging')}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:legal_protection')}
                </Text>
                <Text weight="500" size="textMd">
                    {patient.legalProtection ? t('patients:subject_to') : t('patients:not_subject_to')}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:transportation_modes')}
                </Text>
                <Text weight="500" size="textMd">
                    {t(patientTransportationModesToLabel[patient.transportationMode])}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:local_authority_assistance_service')}
                </Text>
                <Text weight="500" size="textMd">
                    {patient.localAuthorityAssistanceService ? t('patients:provided') : t('patients:not_provided')}
                </Text>
            </DetailsField>
            <DetailsField>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('patients:disability')}
                </Text>
                <Text weight="500" size="textMd">
                    {t(patientDisabilitiesToLabel[patient.disability])}
                </Text>
            </DetailsField>
        </DetailsFieldsGrid>
    )
}
